import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/auth';
import { debugLog } from './common/debugUtilities';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
};

// Exporting only the part of firebase that are needed would be
// ideal
firebase.initializeApp(firebaseConfig);
const firebaseAuth = firebase.auth();
const firebaseStorage = firebase.storage();

// Configure timeouts for large file uploads
// Increase retry time to 10 minutes (600000ms) for upload operations
// This helps with large video files and unstable network connections
firebaseStorage.setMaxUploadRetryTime(600000); // 10 minutes
firebaseStorage.setMaxOperationRetryTime(600000); // 10 minutes

debugLog('Firebase Storage configured with extended timeouts for large uploads');

export {firebaseAuth, firebaseStorage, firebase as default};